{
    "Action.AddComment": "",
    "Action.Close": "",
    "Action.CloseAll": "",
    "Action.ClosePanel": "",
    "Action.CloseTab": "",
    "Action.DeleteComment": "",
    "Action.DeleteFilling": "",
    "Action.DuplicateFilling": "",
    "Action.EditComment": "",
    "Action.EditFilling": "",
    "Action.ExpandTitle": "",
    "Action.Generate": "",
    "Action.GenerateChecklist": "",
    "Action.GenerateTemplates": "",
    "Action.GenerateToWord": "",
    "Action.NameFilling": "",
    "Action.NewFilling": "",
    "Action.OpenAll": "",
    "Action.OpenFilling": "",
    "Action.OpenInDib": "",
    "Action.OpenMenu": "",
    "Action.Reset": "",
    "Action.ResetFields": "",
    "Action.Save": "",
    "Action.SendToDflow": "",
    "Action.WriteAComment": "",
    "Dashboard.pin": "Fest innhold",
    "Dashboard.pinToTop": "",
    "Dashboard.removeFavorite.title": "",
    "Dashboard.removeFromTop": "",
    "Dashboard.unpin": "Fjern festet innhold",
    "Dashboard.unpin.confirm.title": "Fjerne festet innhold?",
    "DocumentGenerator.Alternative": "",
    "DocumentGenerator.ChooseAlternative": "",
    "DocumentGenerator.OptionalContent": "",
    "Error.404Description": "",
    "Error.FetchFillings": "",
    "Error.NoFillingAccess": "",
    "Error.NotFound": "",
    "Error.SomethingWentWrong": "",
    "Error.TryReloadingOrContactUs": "",
    "Error.UnknownArtifact": "",
    "Info.ChooseADocumentToTheLeft": "",
    "Info.DataToDuplicate": "",
    "Info.FillingWithoutName": "",
    "Info.GenerationNotAvailableForDemoUsers": "",
    "Info.IncludeInGeneration": "",
    "Info.MergeDocuments": "",
    "Info.NoAvailableDocuments": "",
    "Info.NoHits": "",
    "Info.RemoveFromGeneration": "",
    "Label.ConfirmAction": "",
    "Label.DIBStandardTemplate": "",
    "Label.DuplicateName": "",
    "Label.MarkAllAsStatus": "",
    "Label.ShowLess": "",
    "Label.ShowMore": "",
    "Navigation.Lookup": "",
    "Phrase.AsEmailAttachment": "",
    "Phrase.AvailableOnDib": "",
    "Phrase.ChooseStyleTemplate": "",
    "Phrase.ChooseStyleTemplatePrompt": "",
    "Phrase.DeliveredAs": "",
    "Phrase.DownloadFile": "",
    "Phrase.DuplicateOfTitle": "",
    "Phrase.FieldsInDocumentGenerator": "",
    "Phrase.InAWordDocument": "",
    "Phrase.IncludeInstructions": "",
    "Phrase.LastEdited": "",
    "Phrase.LoadingModal": "",
    "Phrase.NoAccess": "",
    "Phrase.NoPreviousFillings": "",
    "Phrase.NoResultsOn": "",
    "Phrase.NoSearchResults": "",
    "Phrase.NoTemplatesChosen": "",
    "Phrase.RemoveFilters": "",
    "Phrase.SearchFilling": "",
    "Phrase.SendToDflow": "",
    "Phrase.ShowMore": "",
    "Phrase.SorryYouDoNotHaveAccessToContent": "",
    "Prompt.WouldYouLikeToDeleteFilling": "",
    "Status.Deviation": "",
    "Status.NA": "",
    "Status.Ok": "",
    "Status.Todo": "",
    "Status.WithComment": "",
    "Title.LabelOfContents": "",
    "Title.RelatedContent": "",
    "Title.TemplatesWithCount": "",
    "Type.AuditTemplate": "",
    "Type.ChartOfAccounts": "",
    "Type.ChecklistTemplates": "",
    "Type.Decision": "",
    "Type.Directive": "",
    "Type.Function": "",
    "Type.Handbook": "",
    "Type.JuridiskVejledning": "",
    "Type.Law": "",
    "Type.LegalCommentary": "",
    "Type.Literature": "",
    "Type.Nature": "",
    "Type.News": "",
    "Type.PortalReference": "",
    "Type.PortalSources": "",
    "Type.PortalTools": "",
    "Type.Praktika": "",
    "Type.PreparatoryWorks": "",
    "Type.Q&A": "",
    "Type.Regulation": "",
    "Type.SkatteABC": "",
    "Type.Spreadsheet": "",
    "Type.Standard": "",
    "Type.Statement": "",
    "Type.TaxTreaty": "",
    "Type.Template": "",
    "Type.Topic": "",
    "Type.Unknown": "",
    "Warn.DataToDuplicateNotChosen": "",
    "Warning.AboutToMarkAllChecklistItems": "",
    "Widget.audit.process.title": "",
    "Widget.content.description": "",
    "Widget.content.none": "",
    "Widget.content.title": "",
    "Widget.favourites.title": "",
    "Widget.fillings.description": "",
    "Widget.fillings.none": "",
    "Widget.fillings.title": "",
    "Widget.internal.portal.allAreas": "Alle områder",
    "Widget.internal.portal.content": "Innhold",
    "Widget.internal.portal.history": "Historikk",
    "Widget.internal.portal.history.none": "",
    "Widget.internal.portal.myWork": "Mitt arbeid",
    "Widget.internal.portal.myWork.none": "",
    "Widget.internal.portal.pinned": "Festet",
    "Widget.internal.portal.title": "",
    "Widget.internal.templates.title": "",
    "Widget.last.threads.none": "",
    "Widget.last.threads.title": "",
    "Widget.latest.news.title": "",
    "Widget.threads.description": "",
    "Widget.threads.none": "",
    "Widget.threads.title": "",
    "Word.Abort": "",
    "Word.Checklist": "",
    "Word.Close": "",
    "Word.Comments": "",
    "Word.Confirm": "",
    "Word.Content": "",
    "Word.Created": "",
    "Word.DocumentType": "",
    "Word.Duplicate": "",
    "Word.Edit": "",
    "Word.Email": "",
    "Word.Error": "",
    "Word.Filling": "",
    "Word.Footnote": "",
    "Word.Generate": "",
    "Word.Info": "",
    "Word.Landscape": "",
    "Word.Less": "",
    "Word.More": "",
    "Word.Name": "",
    "Word.New": "",
    "Word.Open": "",
    "Word.PaperOrientation": "",
    "Word.Portrait": "",
    "Word.Remove": "",
    "Word.Sources": "",
    "Word.Status": "",
    "Word.StyleTemplate": "",
    "Word.Template": "",
    "Word.Templates": "",
    "Word.TheSearchText": "",
    "Word.Untitled": "",
    "Word.ZipFile": "",
    "Word.create": "",
    "action.seeLess": "",
    "action.seeMore": "Se flere",
    "alert.MergeConfirmBody": "",
    "alert.MergeConfirmTitle": "",
    "animation.part.0": "",
    "animation.part.1": "",
    "animation.part.2": "",
    "animation.suggestion.1": "",
    "animation.suggestion.2": "",
    "animation.suggestion.3": "",
    "app.title": "",
    "artifact.emailDraft.copied": "",
    "artifact.emailDraft.copyEmail": "",
    "artifact.emailDraft.empty": "",
    "artifact.emailDraft.openInClient": "",
    "artifact.emailDraft.subjectLabel": "",
    "artifact.emailDraft.titleFallback": "",
    "artifact.emailDraft.tooLongWarning": "",
    "artifact.generic.titleFallback": "",
    "artifact.pending.titleFallback": "",
    "artifact.searchResults.noResults": "",
    "artifact.searchResults.resultsFor": "",
    "artifact.searchResults.showFewer": "",
    "artifact.searchResults.showMore": "",
    "artifact.searchResults.titleFallback": "",
    "assistant.answerHeading": "",
    "brand.name": "",
    "callout.suggestplus.common.confirm": "",
    "callout.suggestplus.common.text": "",
    "callout.suggestplus.common.title": "",
    "chat.ephemeral_search.nudge": "",
    "chat.experimentalEngineActive": "Eksperimentell motor",
    "chat.limit.body": "",
    "chat.limit.button": "",
    "chat.limit.heading": "",
    "chat.multi_stream.capacity_message": "",
    "chat.multi_stream.capacity_title": "",
    "common.askQuestion": "",
    "common.cancel": "",
    "common.closeSidebar": "",
    "common.collapseSidebar": "",
    "common.copied": "",
    "common.copy": "",
    "common.defaultThreadTitle": "",
    "common.delete": "",
    "common.disclaimer": "",
    "common.editMessage": "",
    "common.expandSidebar": "",
    "common.getStarted": "",
    "common.goBack": "",
    "common.loadingTranslations": "",
    "common.malerAndChecklists": "",
    "common.newChat": "",
    "common.noResults": "",
    "common.openSidebar": "",
    "common.otherContentFromDIB": "",
    "common.recentChats": "",
    "common.recentSearches": "",
    "common.recentThreads": "",
    "common.regenerate": "",
    "common.rename": "",
    "common.save": "",
    "common.search": "",
    "common.searchBox": "",
    "common.seeAll": "",
    "common.send": "",
    "common.share": "",
    "common.showAll": "",
    "common.showLess": "",
    "common.suggestions": "",
    "common.thinking": "",
    "common.tryAgain": "",
    "common.visibleForAdmins": "",
    "common.yesterday": "",
    "content.comment": "",
    "content.lawRulesMirror": "",
    "content.relatedSources": "Relaterte kilder",
    "content.tags": "",
    "content.translation": "",
    "contextSidebar.BetaDisclaimer": "",
    "contextSidebar.OtherHeading": "",
    "contextSidebar.ThreadExplanation": "",
    "contextSidebar.ToolsHeading": "",
    "contextSidebar.closeContextSidebar": "",
    "contextSidebar.error": "",
    "contextSidebar.noRelatedContent": "",
    "contextSidebar.noRelatedTemplates": "",
    "contextSidebar.openContextSidebar": "",
    "date.last30Days": "",
    "date.lastWeek": "Siste uke",
    "date.previously": "Tidligere",
    "date.today": "",
    "debug.addSuggestion": "",
    "error.contentFilter.body": "",
    "error.contentFilter.title": "",
    "error.contextLength.body": "",
    "error.contextLength.title": "",
    "error.filteredContent.body": "",
    "error.interrupted.body": "",
    "error.interrupted.title": "",
    "error.rateLimit.body": "",
    "error.rateLimit.title": "",
    "error.unknown.body": "",
    "error.unknown.title": "",
    "file.download": "",
    "file.downloadNotForDemo": "",
    "forbidden.description": "",
    "forbidden.title": "",
    "input.placeholder.splash": "",
    "input.placeholder.thread": "",
    "menu.item.desc.deep": "",
    "menu.item.desc.fast": "",
    "menu.item.disabledtooltip.deep": "",
    "menu.item.time.deep": "",
    "menu.item.time.fast": "",
    "menu.item.title.deep": "",
    "menu.item.title.fast": "",
    "name.Dflow": "",
    "prompt.heading.welcome": "",
    "rag.state.answering": "",
    "rag.state.finished": "",
    "rag.state.finishedNoTime": "",
    "rag.state.idle": "",
    "rag.state.reading": "",
    "rag.state.searching": "",
    "rag.state.summarizing": "",
    "rating.addRating": "",
    "rating.comment.placeholder": "",
    "rating.editRating": "",
    "rating.modal.button": "",
    "rating.modal.cancel": "",
    "rating.modal.category.0": "",
    "rating.modal.category.1": "",
    "rating.modal.category.2": "",
    "rating.modal.category.3": "",
    "rating.modal.category.4": "",
    "rating.modal.category.5": "",
    "rating.modal.description": "",
    "rating.modal.elaborate": "",
    "rating.modal.title": "",
    "rating.response.isHelpful": "",
    "rating.response.isNotHelpful": "",
    "rating.submit": "",
    "rating.text": "",
    "references.consideredSources.title": "",
    "references.consideredSources.tooltip": "",
    "references.relatedTools.title": "",
    "references.title": "",
    "reflections.button.text": "",
    "reflections.button.text.loading": "",
    "rename.modal.label": "",
    "rename.modal.title": "",
    "sessionExpired.description": "",
    "sessionExpired.signOut": "",
    "sessionExpired.title": "",
    "settings.accountDetails": "",
    "settings.chatEngine": "Chat-motor",
    "settings.field.chatEngine.experimental": "Eksperimentell",
    "settings.field.chatEngine.standard": "Standard",
    "settings.field.company.description": "",
    "settings.field.company.title": "",
    "settings.field.email.description": "",
    "settings.field.email.title": "",
    "settings.field.name.description": "",
    "settings.field.name.title": "",
    "settings.field.response.deep": "",
    "settings.field.response.fast": "",
    "settings.field.sidebarPosition.left": "",
    "settings.field.sidebarPosition.right": "",
    "settings.language": "",
    "settings.logout": "",
    "settings.preferences": "",
    "settings.responseType": "",
    "settings.showInternalFeatures": "",
    "settings.sidebarPosition": "",
    "settings.title": "",
    "suggestionQuestion.1": "",
    "suggestionQuestion.2": "",
    "table.close": "",
    "table.expand": "",
    "table.fullscreenTitle": "Lukk fullskjerm med krysset helt til høyre, eller trykk <span>Esc<\/span> tasten.",
    "table.openFullscreen": "",
    "thread.postsearch.filters.button": "",
    "thread.postsearch.filters.otherSources": "",
    "thread.postsearch.filters.tools": "",
    "thread.postsearch.note": "",
    "thread.postsearch.resultsFor": "",
    "thread.tabs.answer": "",
    "thread.tabs.answerReady": "",
    "thread.tabs.search": "",
    "topicSidebar.OtherHeading": "",
    "topicSidebar.ToolsHeading": "",
    "userinput.button.text.deep": "",
    "userinput.button.text.fast": "",
    "userinput.placeholder": "",
    "word.Expand": ""
}